export enum RouteName {
  List = 'customer-catalog-list',
}
